import Errored from '../../core/Errored';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import TitledPanel from '../TitledPanel';
import { makeCancelable, sortByProp } from '../../core/utils/utils';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { globalStyles as styles } from '../style/gstheme';
import GS from '../../grafsync/grafsync';
import Chip from '@material-ui/core/Chip';
import PrefixDialog from './PrefixDialog';
import cloneDeep from 'lodash/cloneDeep';
import { Typography } from '@material-ui/core';

class Prefixes extends Component {

  constructor(props) {
    super(props);
    this.state = {
      prefixes: [],
      isLoading: true,
      isErrored: null
    };
    this.cancellable = null;
  }

  componentDidMount() {
    try {
      this.getPrefixes().promise
        .then(data => {
          GS.handle("api-prefixes");
          if (this.cancellable && this.cancellable.isCancelled()) return;
          this.setState({ prefixes: data });
        })
        .catch((e) => {
          if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
        });
    }
    catch (e) {
      if (!this.cancellable || (this.cancellable && !this.cancellable.isCancelled())) this.setState({ isErrored: e });
    }
  }

  getPrefixes() {
    this.cancellable = makeCancelable(GS.prefixes());
    return this.cancellable;
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
  }

  onAddPrefix = (prefix, iri) => {
    let prefixes = cloneDeep(this.state.prefixes);
    prefixes.push({
      iri: iri,
      prefix: prefix
    });
    sortByProp(prefixes, "prefix");
    this.setState({ prefixes });
  };

  clearError = () => this.setState({ isErrored: false });

  render() {

    const { classes, isReadOnly } = this.props;
    const { prefixes, isErrored } = this.state;

    if (isErrored) return <Errored dataTest="api-error" data={isErrored} clearError={this.clearError} />;

    return (
      <TitledPanel dataTest="prefixes" title="Prefixes" actions={!isReadOnly ?
        <PrefixDialog
          prefixes={prefixes}
          onAddPrefix={this.onAddPrefix} />
        :
        null}>
        <div style={{ padding: 12, backgroundColor: 'white' }}>
          <Table style={{ maxWidth: '100%' }}>
            <TableBody data-test="prefix-list">
              {
                prefixes.map((prefixInfo, index) => {
                  return <TableRow key={index} data-test={"row-" + index} classes={{
                    root: classes.stripedRow
                  }}>
                    <TableCell data-test="prefix-text" component="td" className={classes.tableCell}>
                      <Chip
                        data-test={"prefix-" + prefixInfo.prefix}
                        color="primary"
                        clickable={false}
                        label={prefixInfo.prefix}
                        className={classes.chip}
                        style={{ margin: 0 }}
                      />
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <div style={{ paddingTop: 4 }}>
                        <Typography data-test={"iri-text-" + prefixInfo.prefix} variant="body2" className={classes.tableCellText}>{prefixInfo.iri}</Typography>
                      </div>
                    </TableCell>
                  </TableRow>;
                })
              }
            </TableBody>
          </Table>
        </div>
      </TitledPanel>
    );
  }
}

Prefixes.defaultProps = {
  isReadOnly: true
};

Prefixes.propTypes = {
  isReadOnly: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Prefixes);